// El Palacio de las Ofertas — scripts propios (epo-)
document.addEventListener('DOMContentLoaded', function () {
  initEpoReveal();
  initEpoCountdowns();
  initEpoPdpEntrega();
  initEpoCartDrawer();
  initEpoCartPageRec();
  initEpoPdpVariantes();
  initEpoPdpQty();
  initEpoPdpGaleria();
  initEpoPdpSticky();
  initEpoPdpBabf();
  initEpoPdpTonalidades();
  initEpoResenasCarousel();
  initEpoWhatsappFlotante();
  initEpoTituloDinamico();
});

function initEpoReveal() {
  var items = document.querySelectorAll('.epo-reveal');
  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) {
      el.classList.add('epo-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('epo-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  var epoRevealVh = window.innerHeight || document.documentElement.clientHeight;

  items.forEach(function (el, i) {
    el.style.setProperty('--epo-i', i % 6);
    // El primer chequeo del IntersectionObserver no siempre se dispara de
    // inmediato al cargar la página (varios navegadores lo retrasan hasta
    // el próximo scroll/paint real). Eso dejaba contenido que YA estaba
    // visible en pantalla (ej. el bloque de info de la PDP en mobile, con
    // la galería alta empujándolo justo al borde del viewport) con
    // opacity:0 — invisible pero ocupando igual su alto — hasta que el
    // usuario scrolleaba un poco. Si el elemento ya está dentro del
    // viewport al inicializar, lo mostramos directo en vez de esperar al
    // observer; el resto sigue animando al entrar en pantalla como antes.
    var epoRevealRect = el.getBoundingClientRect();
    if (epoRevealRect.top < epoRevealVh - 40 && epoRevealRect.bottom > 0) {
      el.classList.add('epo-visible');
    } else {
      observer.observe(el);
    }
  });
}

function initEpoCountdowns() {
  var blocks = document.querySelectorAll('[data-epo-countdown-diario]');
  if (!blocks.length) return;

  // Uruguay no tiene horario de verano desde 2015: UTC-3 todo el año.
  // Igual usamos Intl con timeZone "America/Montevideo" (en vez de un
  // offset fijo a mano) para que quede correcto solo si esto cambiara.
  var mvFormatter = null;
  try {
    mvFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Montevideo',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  } catch (e) {
    mvFormatter = null;
  }

  // Segundos restantes hasta la próxima medianoche en Uruguay. Se
  // recalcula desde el reloj real en cada tick (no resta un contador
  // local), así que al llegar a 0 automáticamente vuelve a dar ~86400:
  // esto ES el reinicio diario, sin lógica extra para detectarlo.
  function segundosHastaMedianocheMontevideo() {
    var ahora = new Date();
    var h, m, s;
    if (mvFormatter) {
      var partes = mvFormatter.formatToParts(ahora);
      var obj = {};
      partes.forEach(function (p) {
        obj[p.type] = p.value;
      });
      h = parseInt(obj.hour, 10);
      m = parseInt(obj.minute, 10);
      s = parseInt(obj.second, 10);
      if (h === 24) h = 0;
    } else {
      // Fallback si Intl/timeZone no está disponible: offset fijo UTC-3.
      var utcMs = ahora.getTime() + ahora.getTimezoneOffset() * 60000;
      var mv = new Date(utcMs - 3 * 3600000);
      h = mv.getHours();
      m = mv.getMinutes();
      s = mv.getSeconds();
    }
    var segundosDelDia = h * 3600 + m * 60 + s;
    return 86400 - segundosDelDia;
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  blocks.forEach(function (el) {
    var numHoras = el.querySelector('[data-unit="horas"]');
    var numMin = el.querySelector('[data-unit="minutos"]');
    var numSeg = el.querySelector('[data-unit="segundos"]');

    function tick() {
      var restante = segundosHastaMedianocheMontevideo();
      if (restante <= 0 || restante > 86400) restante = 0;

      var horas = Math.floor(restante / 3600);
      var minutos = Math.floor((restante % 3600) / 60);
      var segundos = restante % 60;

      if (numHoras) numHoras.textContent = pad(horas);
      if (numMin) numMin.textContent = pad(minutos);
      if (numSeg) numSeg.textContent = pad(segundos);
    }

    tick();
    setInterval(tick, 1000);
  });
}

// Línea de tiempo de entrega de la PDP.
// Compra = hoy · Despacho = siguiente día hábil · Entrega = 1–2 días hábiles
// después del despacho. Sábados y domingos NO cuentan (más feriados opcionales).
// Se calcula en el navegador con la fecha real de Uruguay porque las páginas
// de producto se cachean y una fecha renderizada server-side quedaría vieja.
function initEpoPdpEntrega() {
  var blocks = document.querySelectorAll('[data-epo-entrega]');
  if (!blocks.length) return;

  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  // "Hoy" en zona horaria America/Montevideo, como Date en UTC-medianoche
  // (así sumar días no se ve afectado por el huso local del visitante).
  function hoyMontevideo() {
    try {
      var partes = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Montevideo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      var o = {};
      partes.forEach(function (p) {
        o[p.type] = p.value;
      });
      return new Date(Date.UTC(parseInt(o.year, 10), parseInt(o.month, 10) - 1, parseInt(o.day, 10)));
    } catch (e) {
      // Fallback: offset fijo UTC-3 (Uruguay no tiene horario de verano desde 2015).
      var n = new Date();
      var utc = n.getTime() + n.getTimezoneOffset() * 60000;
      var mv = new Date(utc - 3 * 3600000);
      return new Date(Date.UTC(mv.getFullYear(), mv.getMonth(), mv.getDate()));
    }
  }

  function iso(d) {
    return d.toISOString().slice(0, 10);
  }

  function esHabil(d, feriados) {
    var wd = d.getUTCDay(); // 0 = domingo, 6 = sábado
    if (wd === 0 || wd === 6) return false;
    return feriados.indexOf(iso(d)) === -1;
  }

  // Avanza 'n' días hábiles a partir de 'd' (sin contar 'd').
  function sumarHabiles(d, n, feriados) {
    var r = new Date(d.getTime());
    var guardas = 0;
    while (n > 0 && guardas < 400) {
      r.setUTCDate(r.getUTCDate() + 1);
      if (esHabil(r, feriados)) n--;
      guardas++;
    }
    return r;
  }

  function fechaTxt(d) {
    return d.getUTCDate() + ' ' + MESES[d.getUTCMonth()];
  }

  function rangoTxt(a, b) {
    if (iso(a) === iso(b)) return fechaTxt(a);
    if (a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear()) {
      return a.getUTCDate() + '–' + fechaTxt(b); // "1–3 sep"
    }
    return fechaTxt(a) + ' – ' + fechaTxt(b); // "30 ago – 2 sep"
  }

  blocks.forEach(function (el) {
    var min = parseInt(el.getAttribute('data-epo-entrega-min'), 10);
    var max = parseInt(el.getAttribute('data-epo-entrega-max'), 10);
    if (isNaN(min) || min < 1) min = 1;
    if (isNaN(max) || max < min) max = Math.max(min, 2);

    var feriados = (el.getAttribute('data-epo-entrega-feriados') || '')
      .split(/[\s,;]+/)
      .map(function (s) {
        return s.trim();
      })
      .filter(function (s) {
        return /^\d{4}-\d{2}-\d{2}$/.test(s);
      });

    var hoy = hoyMontevideo();
    var despacho = sumarHabiles(hoy, 1, feriados);
    // Interior: 1–2 días hábiles después del despacho. Montevideo: cadetería
    // entrega el mismo día del despacho, así que no suma días.
    var interiorMin = sumarHabiles(despacho, min, feriados);
    var interiorMax = sumarHabiles(despacho, max, feriados);

    var elCompra = el.querySelector('[data-epo-entrega-compra]');
    var elDespacho = el.querySelector('[data-epo-entrega-despacho]');
    var elMontevideo = el.querySelector('[data-epo-entrega-montevideo]');
    var elInterior = el.querySelector('[data-epo-entrega-interior]');
    var elEntrega = el.querySelector('[data-epo-entrega-entrega]');

    if (elCompra) elCompra.textContent = fechaTxt(hoy);
    if (elDespacho) elDespacho.textContent = fechaTxt(despacho);
    if (elMontevideo) elMontevideo.textContent = fechaTxt(despacho);
    if (elInterior) elInterior.textContent = rangoTxt(interiorMin, interiorMax);
    // compatibilidad: slot único viejo, si quedara alguno
    if (elEntrega) elEntrega.textContent = rangoTxt(interiorMin, interiorMax);
  });
}

// Cart drawer propio de EPO. "Añadir al carrito" (data-epo-add-cart) agrega
// por AJAX respetando la variante + Llevá 1/2 (lee los mismos inputs ocultos
// name="id" / name="quantity" del formulario de compra) y abre el drawer.
// El contenido del drawer se re-renderiza con la Section Rendering API
// (sections=epo-cart-drawer,cart-icon-bubble) en cada add / change.
// NO toca settings.cart_type ni el drawer nativo de Dawn.
function initEpoCartDrawer() {
  var drawer = document.querySelector('[data-epo-cart]');
  if (!drawer || drawer.getAttribute('data-epo-cart-init')) return;
  drawer.setAttribute('data-epo-cart-init', '1');

  var panel = drawer.querySelector('.epo-cart__panel');
  var inner = drawer.querySelector('[data-epo-cart-inner]');
  var SECTIONS = 'epo-cart-drawer,cart-icon-bubble';
  var routes = window.routes || {};
  var lastFocus = null;
  var opened = false;
  var busy = false;

  function lock(on) {
    document.documentElement.classList.toggle('epo-cart-lock', on);
    document.body.classList.toggle('epo-cart-lock', on);
  }

  // Solo efecto visual: "llena" la barra con transform: scaleX() de 0 a 1.
  // NO calcula nada: el %, el texto y si corresponde envío gratis los
  // decide Liquid (el ancho en reposo ya es correcto vía --epo-envio-pct).
  // Si el entorno no compone frames y la transición queda congelada, una
  // red de seguridad fuerza el estado final para que la barra nunca quede
  // vacía.
  function animarEnvioBarra() {
    var fill = inner.querySelector('[data-epo-envio-prog-fill]');
    if (!fill) return;
    window.clearTimeout(fill._epoAnimT);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { fill.style.transform = ''; return; }
    fill.style.transform = 'scaleX(0)';
    void fill.offsetWidth;
    fill.style.transform = 'scaleX(1)';
    fill._epoAnimT = window.setTimeout(function () {
      var anims = fill.getAnimations ? fill.getAnimations() : [];
      for (var i = 0; i < anims.length; i++) { try { anims[i].finish(); } catch (e) {} }
      fill.style.transform = '';
    }, 850);
  }

  function open() {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    lock(true);
    document.addEventListener('keydown', onKey);
    if (typeof initEpoPdpEntrega === 'function') initEpoPdpEntrega();
    animarEnvioBarra();
    var f = panel.querySelector('[data-epo-cart-close]');
    if (f) { try { f.focus(); } catch (e) {} }
  }

  function close() {
    if (!opened) return;
    opened = false;
    drawer.classList.remove('is-open');
    lock(false);
    document.removeEventListener('keydown', onKey);
    window.setTimeout(function () { if (!opened) drawer.hidden = true; }, 420);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var all = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    var vis = [];
    all.forEach(function (el) { if (el.offsetParent !== null) vis.push(el); });
    if (!vis.length) return;
    var first = vis[0], last = vis[vis.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function applySections(sections) {
    if (sections && sections['epo-cart-drawer']) {
      try {
        var doc = new DOMParser().parseFromString(sections['epo-cart-drawer'], 'text/html');
        var fresh = doc.querySelector('[data-epo-cart-inner]');
        if (fresh) inner.innerHTML = fresh.innerHTML;
      } catch (e) {}
    }
    if (sections && sections['cart-icon-bubble']) {
      var link = document.getElementById('cart-icon-bubble');
      if (link) link.innerHTML = sections['cart-icon-bubble'];
    }
    var countEl = inner.querySelector('[data-epo-cart-count]');
    var count = countEl ? parseInt(countEl.getAttribute('data-count'), 10) || 0 : 0;
    drawer.classList.toggle('is-empty', count === 0);
    if (typeof initEpoPdpEntrega === 'function') initEpoPdpEntrega();
    animarEnvioBarra();
  }

  function cartPost(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; });
    });
  }

  function setBusy(on) {
    busy = on;
    drawer.classList.toggle('is-loading', on);
  }

  function handleAdd(btn) {
    if (busy) return;
    var form = btn.closest('form');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var id = idInput && idInput.value;
    if (!id) return;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(qty) || qty < 1) qty = 1;

    setBusy(true);
    btn.classList.add('is-loading');
    var label = btn.querySelector('[data-epo-add-cart-texto]') || btn;
    var original = label.textContent;
    label.textContent = 'Agregando…';

    cartPost((routes.cart_add_url || '/cart/add') + '.js', {
      items: [{ id: id, quantity: qty }],
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
      .then(function (res) {
        if (!res.ok || (res.body && res.body.status)) {
          throw new Error((res.body && (res.body.description || res.body.message)) || '');
        }
        applySections(res.body.sections);
        open();
      })
      .catch(function (err) {
        showAddError(btn, (err && err.message) ? err.message : 'No se pudo agregar el producto. Probá de nuevo.');
      })
      .then(function () {
        setBusy(false);
        btn.classList.remove('is-loading');
        label.textContent = original;
      });
  }

  function showAddError(btn, msg) {
    var host = btn.parentNode;
    if (!host) return;
    var box = host.querySelector('[data-epo-add-cart-error]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'epo-pdp-hero__cta-error';
      box.setAttribute('data-epo-add-cart-error', '');
      box.setAttribute('role', 'alert');
      host.insertBefore(box, btn.nextSibling);
    }
    box.textContent = msg;
    window.clearTimeout(box._epoT);
    box._epoT = window.setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 6000);
  }

  function changeLine(key, qty) {
    if (busy || !key) return;
    if (isNaN(qty) || qty < 0) qty = 0;
    setBusy(true);
    cartPost((routes.cart_change_url || '/cart/change') + '.js', {
      id: key,
      quantity: qty,
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
      .then(function (res) {
        if (!res.ok) throw new Error('');
        applySections(res.body.sections);
      })
      .catch(function () {
        // Silencioso: si falla, el drawer queda como estaba. El usuario puede reintentar.
      })
      .then(function () { setBusy(false); });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-epo-add-cart]');
    if (add) {
      if (!add.disabled) { e.preventDefault(); handleAdd(add); }
      return;
    }
    var openBtn = e.target.closest('[data-epo-cart-open]');
    if (openBtn) { e.preventDefault(); open(); return; }

    if (!drawer.contains(e.target)) return;

    if (e.target.closest('[data-epo-cart-close]')) { e.preventDefault(); close(); return; }
    var minus = e.target.closest('[data-epo-cart-minus]');
    if (minus) { e.preventDefault(); changeLine(minus.getAttribute('data-key'), parseInt(minus.getAttribute('data-qty'), 10) - 1); return; }
    var plus = e.target.closest('[data-epo-cart-plus]');
    if (plus) { e.preventDefault(); changeLine(plus.getAttribute('data-key'), parseInt(plus.getAttribute('data-qty'), 10) + 1); return; }
    var rem = e.target.closest('[data-epo-cart-remove]');
    if (rem) { e.preventDefault(); changeLine(rem.getAttribute('data-key'), 0); return; }
  });
}

// Recomendación precompra en la página completa /cart (contexto: 'cart').
// Reusa la MISMA selección Liquid del snippet epo-cart-recomendacion; acá solo
// se resuelve el "Agregar": suma por AJAX y re-renderiza las secciones del
// carrito (y el drawer oculto) SIN abrir el drawer. No toca la lógica del
// drawer (data-epo-add-cart) ni el checkout.
function initEpoCartPageRec() {
  var itemsHost = document.getElementById('main-cart-items');
  var footerHost = document.getElementById('main-cart-footer');
  if (!itemsHost || !footerHost) return;
  if (itemsHost.getAttribute('data-epo-rec-init')) return;
  itemsHost.setAttribute('data-epo-rec-init', '1');

  var routes = window.routes || {};
  var busy = false;

  function replaceJsContents(host, htmlString) {
    if (!host || !htmlString) return;
    var target = host.querySelector('.js-contents');
    if (!target) return;
    try {
      var doc = new DOMParser().parseFromString(htmlString, 'text/html');
      var fresh = doc.querySelector('.js-contents');
      if (fresh) target.innerHTML = fresh.innerHTML;
    } catch (e) {}
  }

  function handleRecAdd(btn) {
    if (busy) return;
    var form = btn.closest('[data-epo-cart-rec-form]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var id = idInput && idInput.value;
    if (!id) return;

    busy = true;
    btn.classList.add('is-loading');
    var label = btn.querySelector('[data-epo-cart-rec-add-texto]') || btn;
    var original = label.textContent;
    label.textContent = 'Agregando…';

    var itemsId = itemsHost.dataset.id;
    var footerId = footerHost.dataset.id;
    var sectionList = [itemsId, footerId, 'cart-icon-bubble', 'epo-cart-drawer'].join(',');

    fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: sectionList,
        sections_url: '/cart'
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || (res.body && res.body.status)) {
          throw new Error((res.body && (res.body.description || res.body.message)) || '');
        }
        var s = res.body.sections || {};
        replaceJsContents(itemsHost, s[itemsId]);
        replaceJsContents(footerHost, s[footerId]);
        if (s['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.innerHTML = s['cart-icon-bubble'];
        }
        if (s['epo-cart-drawer']) {
          var inner = document.querySelector('[data-epo-cart-inner]');
          if (inner) {
            try {
              var d = new DOMParser().parseFromString(s['epo-cart-drawer'], 'text/html');
              var freshInner = d.querySelector('[data-epo-cart-inner]');
              if (freshInner) inner.innerHTML = freshInner.innerHTML;
            } catch (e) {}
          }
        }
        if (typeof initEpoPdpEntrega === 'function') initEpoPdpEntrega();
      })
      .catch(function () {
        label.textContent = original;
        btn.classList.remove('is-loading');
        window.location.assign('/cart');
      })
      .then(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-epo-cart-rec-add]');
    if (!add || add.disabled) return;
    e.preventDefault();
    handleRecAdd(add);
  });
}

function initEpoPdpVariantes() {
  var swatches = document.querySelectorAll('[data-epo-pdp-swatch]');
  var scripts = document.querySelectorAll('[data-epo-pdp-variantes-json]');
  if (!swatches.length && !scripts.length) return;

  var variantMap = {};
  scripts.forEach(function (script) {
    try {
      var arr = JSON.parse(script.textContent);
      arr.forEach(function (v) {
        variantMap[v.optionValue] = v;
      });
    } catch (e) {
      /* ignora JSON inválido */
    }
  });

  function aplicarVariante(optionValue) {
    var v = variantMap[optionValue];
    if (!v) return;
    document.dispatchEvent(new CustomEvent('epo:pdp:variant', { detail: v }));
  }

  swatches.forEach(function (el) {
    el.addEventListener('click', function () {
      aplicarVariante(el.getAttribute('data-option-value'));
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        aplicarVariante(el.getAttribute('data-option-value'));
      }
    });
  });

  document.addEventListener('epo:pdp:variant', function (e) {
    var v = e.detail;

    document.querySelectorAll('[data-epo-pdp-swatch]').forEach(function (el) {
      var seleccionado = el.getAttribute('data-option-value') === v.optionValue;
      el.classList.toggle('is-selected', seleccionado);
    });

    document.querySelectorAll('[data-epo-pdp-variant-input]').forEach(function (input) {
      input.value = v.id;
    });

    document.querySelectorAll('[data-epo-pdp-precio]').forEach(function (el) {
      el.textContent = v.priceFormatted;
    });

    document.querySelectorAll('[data-epo-pdp-precio-antes]').forEach(function (el) {
      if (v.compareAtPriceFormatted) {
        el.textContent = v.compareAtPriceFormatted;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });

    var epoAhorroPct = null;
    if (typeof v.compareAtPrice === 'number' && typeof v.price === 'number' && v.compareAtPrice > v.price) {
      epoAhorroPct = Math.round(((v.compareAtPrice - v.price) / v.compareAtPrice) * 100);
    }
    document.querySelectorAll('[data-epo-pdp-ahorro]').forEach(function (el) {
      if (epoAhorroPct !== null) {
        var num = el.querySelector('[data-epo-pdp-ahorro-pct]');
        if (num) num.textContent = epoAhorroPct;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });

    // Selector "Llevá 1 / Llevá 2": mismo precio unitario real, el total
    // de x2 es exactamente precio × 2 (ya calculado en Liquid con | money
    // para que el formato de moneda sea siempre el correcto), sin ningún
    // descuento adicional.
    if (v.priceFormatted) {
      document.querySelectorAll('[data-epo-pdp-qty-total="1"]').forEach(function (el) {
        el.textContent = v.priceFormatted;
      });
      document.querySelectorAll('[data-epo-pdp-qty-unitario="1"]').forEach(function (el) {
        el.textContent = 'Precio por unidad: ' + v.priceFormatted;
      });
      document.querySelectorAll('[data-epo-pdp-qty-unitario="2"]').forEach(function (el) {
        el.textContent = v.priceFormatted + ' c/u';
      });
    }
    if (v.priceX2Formatted) {
      document.querySelectorAll('[data-epo-pdp-qty-total="2"]').forEach(function (el) {
        el.textContent = v.priceX2Formatted;
      });
    }

    // Badge "🔥 Ahorrás $X" junto a "Llevá 1" / "Llevá 2": el importe ya
    // viene calculado en Liquid (compare_at_price - price, x1 y x2), acá
    // solo se actualiza el texto y se oculta si la variante no tiene un
    // compare_at_price válido.
    document.querySelectorAll('[data-epo-pdp-qty-ahorro="1"]').forEach(function (el) {
      if (v.ahorroFormatted) {
        var m = el.querySelector('[data-epo-pdp-qty-ahorro-monto="1"]');
        if (m) m.textContent = v.ahorroFormatted;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    document.querySelectorAll('[data-epo-pdp-qty-ahorro="2"]').forEach(function (el) {
      if (v.ahorroX2Formatted) {
        var m2 = el.querySelector('[data-epo-pdp-qty-ahorro-monto="2"]');
        if (m2) m2.textContent = v.ahorroX2Formatted;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });

    if (v.image) {
      // Primero intenta mover la galería (track deslizable) a la slide
      // real que corresponde a esta variante. Solo si esa imagen no está
      // entre las slides (caso borde) cae al comportamiento anterior de
      // pisar el src de la imagen principal directamente.
      var epoGaleriaWrap = document.querySelector('.epo-pdp-hero__galeria');
      var epoGaleriaMovida =
        epoGaleriaWrap && typeof epoGaleriaWrap.epoIrAImagen === 'function' && epoGaleriaWrap.epoIrAImagen(v.image);

      if (!epoGaleriaMovida) {
        document.querySelectorAll('[data-epo-pdp-main-img]').forEach(function (img) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = v.image;
        });
      }

      document.querySelectorAll('[data-epo-pdp-sticky-img]').forEach(function (img) {
        img.removeAttribute('srcset');
        img.src = v.image;
      });
      var base = function (u) {
        if (!u) return u;
        try {
          return new URL(u, window.location.href).pathname;
        } catch (e) {
          return u;
        }
      };
      document.querySelectorAll('[data-epo-pdp-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', base(t.getAttribute('data-img')) === base(v.image));
      });
    }

    document.querySelectorAll('[data-epo-pdp-submit]').forEach(function (btn) {
      btn.disabled = !v.available;
    });

    document.querySelectorAll('[data-epo-pdp-opcion-actual]').forEach(function (el) {
      el.textContent = v.optionValue;
    });
  });
}

// Selector "Llevá 1 / Llevá 2" del bloque principal de compra. Solo
// cambia la cantidad real (input hidden "quantity" del mismo form que ya
// envía el id de variante), nunca el precio unitario: no hay descuento
// por llevar 2, el total de esa tarjeta ya viene calculado desde Liquid
// (y actualizado en initEpoPdpVariantes) como precio real × 2.
function initEpoPdpQty() {
  var wraps = document.querySelectorAll('[data-epo-pdp-qty]');
  if (!wraps.length) return;

  wraps.forEach(function (wrap) {
    var form = wrap.closest('form');
    var qtyInput = form ? form.querySelector('[data-epo-pdp-qty-input]') : null;
    var opciones = wrap.querySelectorAll('[data-epo-pdp-qty-opcion]');
    var radios = wrap.querySelectorAll('[data-epo-pdp-qty-radio]');

    function seleccionar(valor) {
      opciones.forEach(function (op) {
        op.classList.toggle('is-selected', op.getAttribute('data-epo-pdp-qty-opcion') === valor);
      });
      if (qtyInput) qtyInput.value = valor;
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) seleccionar(radio.value);
      });
    });
  });
}

// Galería principal: en vez de un único <img> cuyo src se pisaba al
// tocar una miniatura, ahora hay un track horizontal con una slide por
// imagen (scroll-snap nativo del navegador — sin librería de carrusel).
// Esto permite deslizar con el dedo en mobile y agrega flechas discretas
// para desktop, mientras las miniaturas siguen funcionando igual que
// antes (ahora navegan el track en vez de cambiar un src).
function initEpoPdpGaleria() {
  var galerias = document.querySelectorAll('.epo-pdp-hero__galeria');
  if (!galerias.length) return;

  function basePath(u) {
    if (!u) return u;
    try {
      return new URL(u, window.location.href).pathname;
    } catch (e) {
      return u;
    }
  }

  galerias.forEach(function (wrapper) {
    var track = wrapper.querySelector('[data-epo-pdp-track]');
    var slides = Array.prototype.slice.call(wrapper.querySelectorAll('[data-epo-pdp-slide]'));
    var thumbs = Array.prototype.slice.call(wrapper.querySelectorAll('[data-epo-pdp-thumb]'));
    var prevBtn = wrapper.querySelector('[data-epo-pdp-flecha="prev"]');
    var nextBtn = wrapper.querySelector('[data-epo-pdp-flecha="next"]');
    if (!track || slides.length < 2) return;

    function indiceActual() {
      var centro = track.scrollLeft + track.clientWidth / 2;
      var mejor = 0;
      var mejorDist = Infinity;
      slides.forEach(function (s, i) {
        var dist = Math.abs(s.offsetLeft + s.offsetWidth / 2 - centro);
        if (dist < mejorDist) {
          mejorDist = dist;
          mejor = i;
        }
      });
      return mejor;
    }

    function actualizarActivo() {
      var i = indiceActual();
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-index'), 10) === i);
      });
      if (prevBtn) prevBtn.disabled = i === 0;
      if (nextBtn) nextBtn.disabled = i === slides.length - 1;
    }

    function irASlide(index, animado) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: animado === false ? 'auto' : 'smooth' });
    }

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(actualizarActivo, 100);
      },
      { passive: true }
    );

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        irASlide(parseInt(thumb.getAttribute('data-index'), 10));
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        irASlide(indiceActual() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        irASlide(indiceActual() + 1);
      });
    }

    // Usado por initEpoPdpVariantes: mueve la galería a la slide cuya
    // imagen coincida con la de la variante elegida (misma comparación
    // por pathname que ya usan las miniaturas). Devuelve false si esa
    // imagen no forma parte de la galería del producto.
    wrapper.epoIrAImagen = function (url) {
      var destino = basePath(url);
      var idx = -1;
      slides.forEach(function (s, i) {
        if (idx === -1 && basePath(s.getAttribute('data-img')) === destino) idx = i;
      });
      if (idx === -1) return false;
      irASlide(idx, false);
      actualizarActivo();
      return true;
    };

    actualizarActivo();
  });
}

function initEpoPdpSticky() {
  var barra = document.querySelector('[data-epo-pdp-sticky]');
  if (!barra) return;

  var selector = barra.getAttribute('data-observar');
  var objetivo = selector ? document.querySelector(selector) : null;
  if (!objetivo) return;

  var esperando = false;

  function actualizar() {
    var rect = objetivo.getBoundingClientRect();
    var pasoElBoton = rect.bottom < 0;
    barra.classList.toggle('is-visible', pasoElBoton);
  }

  function solicitarActualizacion() {
    if (esperando) return;
    esperando = true;
    setTimeout(function () {
      esperando = false;
      actualizar();
    }, 100);
  }

  window.addEventListener('scroll', solicitarActualizacion, { passive: true });
  window.addEventListener('resize', solicitarActualizacion);
  actualizar();
}

function initEpoPdpBabf() {
  var rangos = document.querySelectorAll('[data-epo-babf-range]');
  if (!rangos.length) return;

  rangos.forEach(function (rango) {
    var contenedor = rango.closest('[data-epo-babf]');
    if (!contenedor) return;

    function actualizar() {
      contenedor.style.setProperty('--epo-babf-pos', rango.value + '%');
    }

    rango.addEventListener('input', actualizar);
    actualizar();
  });
}

// PDP: comparador de tonalidades de luz. Tabs que cambian la imagen visible
// y (si hay) la descripción. Sin dependencias; degrada mostrando el 1er estado.
function initEpoPdpTonalidades() {
  var bloques = document.querySelectorAll('[data-epo-pdp-ton]');
  if (!bloques.length) return;

  bloques.forEach(function (root) {
    var opciones = root.querySelectorAll('[data-epo-pdp-ton-opcion]');
    var slides = root.querySelectorAll('[data-epo-pdp-ton-slide]');
    var descs = root.querySelectorAll('[data-epo-pdp-ton-desc]');
    if (!opciones.length || !slides.length) return;

    function activar(idx) {
      opciones.forEach(function (o) {
        var on = o.getAttribute('data-index') === String(idx);
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      slides.forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-index') === String(idx));
      });
      descs.forEach(function (d) {
        d.classList.toggle('is-active', d.getAttribute('data-index') === String(idx));
      });
    }

    opciones.forEach(function (o) {
      o.addEventListener('click', function () {
        activar(parseInt(o.getAttribute('data-index'), 10) || 0);
      });
    });
  });
}

function initEpoWhatsappFlotante() {
  var boton = document.querySelector('[data-epo-whatsapp]');
  if (!boton) return;

  var barra = document.querySelector('.epo-pdp-sticky');
  if (!barra) return;

  function actualizarOffset() {
    if (barra.classList.contains('is-visible')) {
      var altura = barra.offsetHeight;
      boton.style.setProperty('--epo-wa-offset', (altura + 14) + 'px');
    } else {
      boton.style.setProperty('--epo-wa-offset', '0px');
    }
  }

  var observer = new MutationObserver(actualizarOffset);
  observer.observe(barra, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', actualizarOffset);
  actualizarOffset();
}

function initEpoResenasCarousel() {
  var carruseles = document.querySelectorAll('[data-epo-resenas-carousel]');
  if (!carruseles.length) return;

  carruseles.forEach(function (carrusel) {
    var track = carrusel.querySelector('[data-epo-resenas-track]');
    var prev = carrusel.querySelector('[data-epo-resenas-prev]');
    var next = carrusel.querySelector('[data-epo-resenas-next]');
    var slides = track ? track.querySelectorAll('.epo-resenas-carousel__slide') : [];
    if (!track || slides.length < 2) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }

    var pausado = false;
    var reanudarTimeout = null;

    function pasoScroll() {
      var slide = slides[0];
      var estilo = window.getComputedStyle(track);
      var gap = parseFloat(estilo.columnGap || estilo.gap || 0) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function actualizarFlechas() {
      if (!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    function avanzar() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      if (track.scrollLeft >= maxScroll) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: pasoScroll(), behavior: 'smooth' });
      }
    }

    function retroceder() {
      if (track.scrollLeft <= 2) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: -pasoScroll(), behavior: 'smooth' });
      }
    }

    function pausarTemporal() {
      pausado = true;
      clearTimeout(reanudarTimeout);
      reanudarTimeout = setTimeout(function () {
        pausado = false;
      }, 7000);
    }

    if (next) next.addEventListener('click', function () { avanzar(); pausarTemporal(); });
    if (prev) prev.addEventListener('click', function () { retroceder(); pausarTemporal(); });
    track.addEventListener('pointerdown', pausarTemporal, { passive: true });
    track.addEventListener('touchstart', pausarTemporal, { passive: true });
    track.addEventListener('wheel', pausarTemporal, { passive: true });

    var actualizandoFlechas = false;
    track.addEventListener('scroll', function () {
      if (actualizandoFlechas) return;
      actualizandoFlechas = true;
      requestAnimationFrame(function () {
        actualizarFlechas();
        actualizandoFlechas = false;
      });
    }, { passive: true });

    actualizarFlechas();

    var prefiereMenosMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefiereMenosMovimiento) {
      setInterval(function () {
        if (pausado) return;
        avanzar();
      }, 5000);
    }
  });
}

/**
 * Título dinámico de la pestaña (retención).
 * Con la pestaña visible: se mantiene el <title> real de la página.
 * Con la pestaña oculta (otra pestaña / minimizado): rota frases cada ~3s.
 * Al volver: se detiene el timer y se restaura el título real de inmediato.
 * Usa document.visibilityState / visibilitychange. Sin focus/blur, sin librerías,
 * sin tocar SEO/canonical/OG. Guard para no duplicar listener ni timers.
 */
function initEpoTituloDinamico() {
  if (window.__epoTituloDinamicoOn) return;
  window.__epoTituloDinamicoOn = true;

  // En el editor de temas no queremos alterar el título mientras el comercio edita.
  if (window.Shopify && window.Shopify.designMode) return;

  var TITULO_REAL = document.title;
  var INTERVALO_MS = 3000;

  var FRASE_CARRITO = 'Tu carrito te está esperando 🛒';
  var FRASES_SIN_CARRITO = ['Volvé 👀', 'Estás a un click ✅', 'Últimas unidades ⚡'];

  var timer = null;
  var idx = 0;

  function carritoConItems() {
    var el = document.querySelector('[data-epo-cart-count]');
    if (!el) return false;
    var n = parseInt(el.getAttribute('data-count'), 10);
    return !isNaN(n) && n > 0;
  }

  function construirFrases() {
    if (carritoConItems()) {
      // Prioridad a la frase del carrito: primera y en slots alternos.
      return [
        FRASE_CARRITO,
        'Volvé 👀',
        FRASE_CARRITO,
        'Estás a un click ✅',
        FRASE_CARRITO,
        'Últimas unidades ⚡'
      ];
    }
    return FRASES_SIN_CARRITO.slice();
  }

  function detener() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function iniciar() {
    detener(); // evita timers duplicados
    var frases = construirFrases();
    idx = 0;
    document.title = frases[0];
    idx = 1;
    timer = setInterval(function () {
      document.title = frases[idx % frases.length];
      idx++;
    }, INTERVALO_MS);
  }

  function onVisibilityChange() {
    if (document.visibilityState === 'hidden') {
      iniciar();
    } else {
      detener();
      document.title = TITULO_REAL;
    }
  }

  document.addEventListener('visibilitychange', onVisibilityChange);

  // Por si la página cargó ya en segundo plano.
  if (document.visibilityState === 'hidden') iniciar();
}
